import React, { Component, ReactNode } from 'react'
import { setupSentry, reportError } from '../../sentry'
import sendInterstitialEvent from '../../../tracking/sendInterstitialEvent/sendInterstitialEvent'
import ErrorWithContext from './ErrorWithContext'
import Fallback from './Fallback/Fallback'

interface ErrorBoundaryProps {
  children: ReactNode
  theme: 'dark' | 'default'
  onClose: () => void
  bespokeId?: string
  locale: string
  adServerUrl: string
  placementKey: string
  adId?: string
  showKlarnaLogo?: boolean
}

interface ErrorBoundaryState {
  hasError: boolean
}

setupSentry()

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(_: Error): ErrorBoundaryState {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error: ErrorWithContext) {
    console.error('ErrorBoundary caught an error', error)
    reportError({
      ...this.props,
      responseBody: error.responseBody,
      responseStatus: error.responseStatus
    }, error)
    sendInterstitialEvent(this.props.locale, 'interstitial_error', {
      ...this.props,
      error: JSON.stringify(error),
      type: 'learn-more',
      k: this.props?.adId,
    })
  }

  render() {
    if (this.state.hasError) {
      return <Fallback {...this.props} />
    }

    return this.props.children
  }
}

export default ErrorBoundary
